<template>
	<div class="box-content" :class="{ frame: $store.getters.isPc }" onselectstart="return false;" v-loading="loading">
		<div class="row header">
			<div class="col left-view">
				<span class="res-text">查询结果</span>
				<span class="block"></span>
				<span class="authorization"></span>
			</div>
			<div class="medal"></div>
		</div>
		<div class="col cc main">
			<div class="row cb line">
				<span class="label">机构名称</span>
				<span class="value">{{ detail.name }}</span>
			</div>
			<div class="row cb line">
				<span class="label">授权时间</span>
				<span class="value">{{ detail.grant_time_text }}</span>
			</div>
			<div class="row cb line">
				<span class="label">到期时间</span>
				<span class="value">{{ detail.expire_time_text }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { Message } from 'element-ui';
export default {
	data() {
		return {
			detail: {},
			loading: true
		};
	},
	components: {},
	beforeCreate() {},
	created() {
		this.service1('cert/serarchMech', { name: this.$route.params.name }).then(res => {
			if (res.code === 0) {
				if (this.$store.getters.isPc) {
					Message.error(res.msg);
				} else {
					Toast(res.msg);
				}
			} else {
				this.detail = res.data;
				this.loading = false;
			}
		});
	},
	methods: {}
};
</script>
<style lang="less" scoped>
.header {
	width: 100%;
	height: 6.933333rem;
	background-color: #007475;
	color: #ffffff;
	padding: 0.8rem 0 0.8rem 0.8rem;
	box-sizing: border-box;
	justify-content: space-between;
	.left-view {
		.res-text {
			font-size: 0.4rem;
		}
		.block {
			width: 0.613333rem;
			height: 0.08rem;
			background: #ffffff;
			margin: 0.373333rem 0;
		}
		.authorization {
			width: 4.533333rem;
			height: 0.64rem;
			background: url(../../assets/partner/authorization.png) no-repeat center;
			background-size: cover;
		}
	}
	.medal {
		margin-top: 0.4rem;
		width: 3.173333rem;
		height: 2.853333rem;
		background: url(../../assets/partner/medal.png) no-repeat center;
		background-size: cover;
	}
}
.box-content {
	position: relative;
}
.main {
	width: 92%;
	height: 5.146666rem;
	box-shadow: 0 0.24rem 0.32rem 0 rgba(222, 222, 222, 0.59);
	border-radius: 0.266666rem;
	position: absolute;
	top: 3.733333rem;
	background-color: #ffffff;
	left: 0;
	right: 0;
	margin: auto;
	padding: 0 0.533333rem;
	box-sizing: border-box;
	.line {
		width: 100%;
		font-size: 0.373333rem;
		height: 1.44rem;
		border-bottom: 1px solid #dddddd;
		&:last-child {
			border: none;
		}
		.label {
			color: #666666;
		}
		.value {
			color: #000000;
			font-weight: Medium;
		}
	}
}
</style>
